import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NucleusUserNavigatorContract } from '@nucleus/user-ui';
import { AuditTraceComponent } from '../../common/audit-trace/audit-trace.component';

/**
 * Tasksense navigator — wires the lib's navigation hooks into Router +
 * the existing AuditTrace dialog. Mirrors bookwise + goldfish.
 */
@Injectable({ providedIn: 'root' })
export class TasksenseUserNavigatorAdapter implements NucleusUserNavigatorContract {
  private readonly router = inject(Router);
  private readonly dialog = inject(MatDialog);

  toUserEdit(username: string | null): void {
    if (username) {
      this.router.navigate(['/administration/user', username]);
    } else {
      this.router.navigate(['/administration/user']);
    }
  }

  toUsersList(): void {
    this.router.navigate(['/administration/users']);
  }

  openAuditTrail(entityName: string, entityId: string): void {
    this.dialog.open(AuditTraceComponent, {
      panelClass: 'bw-dialog-panel',
      width: '1100px',
      maxWidth: '95vw',
      height: '72vh',
      data: { entityName, entityId },
    });
  }
}
